import { PlusIcon } from '@redis-ui/icons';
import { ActionIconButtonProps } from '@redis-ui/components';
import * as S from './PlusButton.style';
import { PlainFunction } from '../../types/interfaces';
import { PermissionKey } from '../PermissionsProtectors/protectedComponents.types';
import ProtectedComponent from '../PermissionsProtectors/components/ProtectedComponent/ProtectedComponent';

interface IProps {
  onClick?: PlainFunction;
  disabled?: boolean;
  testIdSuffix?: string;
  className?: string;
  ariaLabel?: string;
  requiredPermissions?: PermissionKey;
  size?: ActionIconButtonProps['size'];
  variant?: ActionIconButtonProps['variant'];
}

const PlusButton = ({
  onClick,
  disabled,
  testIdSuffix = 'new-row',
  className,
  ariaLabel,
  requiredPermissions,
  size = 'L',
  variant = 'primary'
}: IProps) => {
  const PlusButtonComponent = (
    <S.PlusButton
      data-testid={`button--add-${testIdSuffix}`}
      aria-label={ariaLabel}
      onClick={onClick}
      variant={variant}
      size={size}
      icon={PlusIcon}
      {...{ disabled, className }}
    />
  );

  if (requiredPermissions) {
    return (
      <ProtectedComponent requiredPermissions={requiredPermissions}>
        {PlusButtonComponent}
      </ProtectedComponent>
    );
  }

  return PlusButtonComponent;
};

export default PlusButton;
